import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
let queryClient = null;
export function getQueryClient() {
    if (!queryClient) {
        queryClient = new QueryClient({
            defaultOptions: env.serverless && env.dev && !env.client
                ? {
                    queries: {
                        staleTime: 1,
                    },
                }
                : {},
        });
    }
    return queryClient;
}
export function QueryProvider(props) {
    return _jsx(QueryClientProvider, { client: getQueryClient(), children: props.children });
}
